export default __webpack_public_path__ + "static/media/mtt_felixmacovei.1b220cdd.jpg";